import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import {
  getOfferListPagePath,
  CORPORATE_CUSTOMER,
  PRIVATE_CUSTOMER,
} from "constants/customerTypes";

import { useNavigation } from "../../../contexts/navigation/NavigationContext";

function InvalidCustomerTypeModal({
  customerType: currentCustomerType,
  hideModal,
}) {
  const [navigate] = useNavigation();
  const [t] = useTranslation();

  const handleButtonClick = useCallback(() => {
    const path = getOfferListPagePath(currentCustomerType);

    hideModal();

    navigate(path);
  }, [
    currentCustomerType,
    hideModal,
    navigate,
  ]);

  const validCustomerType = (
    currentCustomerType === PRIVATE_CUSTOMER
      ? CORPORATE_CUSTOMER
      : PRIVATE_CUSTOMER
  );

  const validCustomerTypePlural = t(`checkout.customer_type.${String(validCustomerType).toLowerCase()}_plural`);
  const currentCustomerTypePlural = t(`checkout.customer_type.${String(currentCustomerType).toLowerCase()}_plural`);

  return (
    <section className="container p-5 max-w-md m-auto flex flex-col p-5 items-center">
      <p className="text-md font-bold mb-3">
        {t("checkout.this_offer_is_only_for", {
          customerTypePlural: validCustomerTypePlural,
        })}
      </p>

      <p className="text-sm font-normal mb-3">
        {t("checkout.you_will_find_a_good_offer", {
          customerTypePlural: currentCustomerTypePlural,
        })}
      </p>

      <button
        type="button"
        onClick={handleButtonClick}
        className="btn btn--primary btn--large max-w-full mt-4 flex justify-center"
      >
        {t("checkout.to_the_offers_for", {
          customerTypePlural: currentCustomerTypePlural,
        })}
      </button>
    </section>
  );
}

export default InvalidCustomerTypeModal;
